import { Do, timer } from '../../universal';
import { $, React, _ } from '../lib';
import { contentComponent, openNavLinkMaybe } from './component-frame';
import { MFALoginForm } from './component-mfa-login';
import { reactFlyout } from './component-react';
import { runeSpeedTestBroadcast, showBroadcastMessage } from './component-trionline';
import { Button } from './ui5';
const irislog = (s) => {
    const css1 = 'color:#f96';
    const css2 = 'color:#888';
    console.log(`%c[IRIS] %c${s}`, css1, css2);
};
export class IrisClient {
    isConnecting;
    isConnected;
    responseRegister;
    messageQueueTimeout;
    messageQueue;
    initialised;
    disconnections;
    history;
    messageCount;
    cachedHosts;
    excludeSpinner;
    gcTimer;
    wsObject;
    reconnectAttempts;
    responseReigster;
    constructor() {
        this.isConnecting = false;
        this.isConnected = false;
        this.responseRegister = {};
        this.messageQueueTimeout = null;
        this.messageQueue = [];
        this.initialised = false;
        this.disconnections = 0;
        this.history = {};
        this.messageCount = 0;
        this.cachedHosts = null;
        this.reconnectAttempts = 0;
        this.excludeSpinner = {
            0: _.times(999, x => x + 1),
            1: [0, 14, 23, 30, 31, 49, 53, 56, 80, 81, 82, 84, 88],
        };
        const gcfn = () => {
            this.garbageCollect();
        };
        this.gcTimer = setInterval(gcfn, 60000);
        setTimeout(gcfn, 5000);
    }
    Run() {
        if (this.initialised) {
            throw new Error('IRIS connection already running');
        }
        this.initialised = true;
        this.Connect().catch(error => {
            console.error('Failed to connect to IRIS', error);
        });
    }
    async getIRISHosts() {
        if (this.cachedHosts) {
            return this.cachedHosts;
        }
        const response = await fetch('/reverse-host-iris/');
        if (response.status >= 400) {
            return this.cachedHosts;
        }
        const data = await response.text();
        this.cachedHosts = JSON.parse(data);
        return this.cachedHosts;
    }
    async getWebsocketURI() {
        const page = Do(() => {
            const P = location.href.split('#')[0] ?? '';
            return P.split('://')[1]?.substring(location.host.length) ?? '';
        });
        const session_key = getCookies().get('SessionKey') ?? '';
        const hosts = await this.getIRISHosts();
        if (!hosts) {
            irislog('No IRIS hosts found');
            return null;
        }
        const reverseHostFlask = hosts.reverseFlask ?? location.host;
        const reverseHostSvrts = hosts.reverseSvrts ?? location.host;
        const fullHost = hosts.public ?? 'wss://iris.trionline.com.au:443';
        return `${fullHost}/?d=${page}|||${session_key}|||${reverseHostFlask}|||${reverseHostSvrts}`;
    }
    async Connect() {
        if (this.isConnecting === true) {
            return;
        }
        irislog('Connecting to IRIS...');
        this.isConnecting = true;
        let urlFetched = false;
        setTimeout(() => {
            if (!urlFetched) {
                irislog('Performing reset of connection to IRIS');
                this.isConnecting = false;
                this.Connect().catch(error => {
                    console.error('Failed to reconnect to IRIS', error);
                });
            }
        }, 2000);
        const uri = await this.getWebsocketURI();
        urlFetched = true;
        if (uri == null) {
            return;
        }
        if ($('html').hasClass('noiris')) {
            return;
        }
        this.wsObject?.close();
        this.wsObject = new WebSocket(uri);
        this.wsObject.onopen = () => {
            this.onConnect();
        };
        this.wsObject.onclose = () => {
            this.onDisconnect();
        };
        this.wsObject.onmessage = e => {
            this.onReceive(e.data);
        };
    }
    onConnect() {
        this.isConnecting = false;
        this.isConnected = true;
        this.reconnectAttempts = 0;
        irislog('Connected to IRIS');
        errorReconnectingFlyout?.Close();
        clearTimeout(this.messageQueueTimeout);
        this.messageQueueTimeout = null;
        this.messageQueue.forEach(cmd => {
            this.sendRaw(cmd);
        });
        this.messageQueue = [];
    }
    onDisconnect() {
        this.isConnecting = false;
        if (this.isConnected) {
            this.isConnected = false;
            irislog('Disconnected from IRIS');
            this.reconnectAttempts = 0;
            this.disconnections += 1;
            if (this.disconnections < 10) {
                timer(500, () => {
                    this.Connect().catch(error => {
                        console.error('Failed to reconnect to IRIS', error);
                    });
                });
            }
        }
        else {
            this.reconnectAttempts = (this.reconnectAttempts ?? 0) + 1;
            irislog(`Attempting to reconnect to IRIS: #${this.reconnectAttempts}`);
            let duration = 10000;
            if (this.reconnectAttempts < 10) {
                duration = 500;
            }
            else if (this.reconnectAttempts < 20) {
                duration = 3000;
            }
            else {
                showErrorReconnectingMessage();
            }
            timer(duration, () => {
                this.Connect().catch(error => {
                    console.error('Failed to reconnect to IRIS', error);
                });
            });
        }
    }
    sendRaw(obj) {
        if (!this.wsObject || this.wsObject.readyState > 1 || !this.isConnected) {
            this.messageQueue.push(obj);
            this.Connect().catch(error => {
                console.error('Failed to reconnect to IRIS', error);
            });
            return;
        }
        try {
            const reqJSON = JSON.stringify(obj);
            this.wsObject.send(reqJSON);
        }
        catch (e) {
            console.error(e);
            this.messageQueue.push(obj);
            if (this.messageQueueTimeout === null) {
                this.messageQueueTimeout = timer(15000, () => {
                    irislog('Failed to reconnect to IRIS');
                });
            }
        }
    }
    Send(obj) {
        if (!obj.data) {
            throw new Error('Data cannot be empty');
        }
        if (typeof obj.data !== 'object') {
            throw new Error('Data must be an object');
        }
        const requestID = Math.random().toString(36).substr(2);
        obj.data.requestID = requestID;
        this.responseRegister[requestID] = {
            created: _.now(),
            yes: obj.yes ?? _.noop,
            no: obj.no ??
                (data => {
                    console.error(data);
                }),
            any: obj.any ?? _.noop,
            prog: obj.prog ?? _.noop,
        };
        this.history[requestID] = {
            In: obj.data,
            Sent: _.now(),
            Out: null,
            Received: null,
            Taken: null,
        };
        this.sendRaw(obj.data);
        const progID = Number(obj.data.progID ?? -1);
        if (!(this.excludeSpinner[progID] ?? []).includes(obj.data.funcID)) {
            this.messageCount++;
        }
        if (this.messageCount > 0) {
            return document.querySelector('.lds-dual-ring')?.classList.remove('hidden');
        }
    }
    async SendPromise(data) {
        return new Promise((resolve, reject) => {
            this.Send({
                data,
                yes: data => {
                    resolve(data);
                },
                no: data => {
                    reject(data);
                },
            });
        });
    }
    onReceive(message) {
        let responseObj = null;
        try {
            responseObj = JSON.parse(message);
        }
        catch (error) {
            console.error(`Error decoding -> ${message}`);
            return;
        }
        if (responseObj.error === 'InvalidSession' && !window.allowIRISWithoutLogin) {
            console.info('Page refresh - invalid session');
            location.reload();
            return;
        }
        const reqID = responseObj.requestID;
        const callbacks = this.responseRegister[reqID];
        if (!callbacks) {
            if (responseObj.isProgressReport) {
                return;
            }
            irislog(`Received broadcast: ${responseObj.progID}/${responseObj.funcID}`);
            if (responseObj.progID === 0 && responseObj.funcID === 5) {
                if (responseObj.message.startsWith('redirect:')) {
                    const url = responseObj.message.substring('redirect:'.length).trim();
                    if (typeof openNavLinkMaybe !== 'undefined' &&
                        openNavLinkMaybe !== null) {
                        openNavLinkMaybe(url);
                    }
                    else {
                        location.href = url;
                    }
                    return;
                }
                showBroadcastMessage(responseObj.message);
                return;
            }
            if (responseObj.progID === 0 && responseObj.funcID === 12) {
                runeSpeedTestBroadcast(responseObj);
                return;
            }
            if (responseObj.progID === 0 && responseObj.funcID === 16) {
                console.info('Forcing page refresh from IRIS');
                location.reload();
                return;
            }
            ;
            (window.irisOnUnsolicited ?? _.noop)(responseObj);
            return;
        }
        if (responseObj.isProgressReport) {
            callbacks.prog(responseObj.progress);
            return;
        }
        responseObj.timerComplete = _.now() - callbacks.created;
        if (responseObj.mfaRequired) {
            reactFlyout('MFA Elevation Required', [380, 360], {
                tag: MFALoginForm,
                onCloseFailed: () => {
                    callbacks.no(responseObj);
                    callbacks.any(responseObj);
                },
                onComplete: () => {
                    IRIS.Send({
                        data: responseObj._original,
                        any: callbacks.any,
                        no: callbacks.no,
                        yes: callbacks.yes,
                    });
                },
            });
        }
        else {
            if (responseObj.completed) {
                callbacks.yes(responseObj);
            }
            else {
                callbacks.no(responseObj);
            }
            callbacks.any(responseObj);
        }
        contentComponent()?.UpdateTitle?.();
        const req = this.history[reqID];
        if (req != null) {
            req.Out = responseObj;
            req.Received = _.now();
            req.Taken = req.Received - req.Sent;
        }
        delete this.responseRegister[reqID];
        if (!(this.excludeSpinner[responseObj._original.progID] ?? []).includes(responseObj._original.funcID)) {
            this.messageCount--;
        }
        if (this.messageCount < 1) {
            return document.querySelector('.lds-dual-ring')?.classList.add('hidden');
        }
    }
    showHistory() {
        return _.sortBy(this.history, 'Sent');
    }
    garbageCollect() {
        let saved_space = 0;
        _.forEach(this.responseRegister, (v, k) => {
            const ms_ago = _.now() - v.Created;
            if (ms_ago > 5 * 60 * 1000) {
                const { progID, funcID } = this.history[k]?.In;
                if (progID === 0 && funcID === 4) {
                    saved_space += +JSON.stringify(this.responseReigster[k]);
                    delete this.responseRegister[k];
                    return;
                }
            }
        });
        _.forEach(this.history, (v1, k1) => {
            if (v1 == null) {
                return;
            }
            const ms_ago = _.now() - v1.Sent;
            if (ms_ago > 60 * 60 * 1000) {
                saved_space += JSON.stringify(v1).length;
                delete this.history[k1];
                return;
            }
            if (v1.Out != null) {
                const keys_to_remove = ['_original', 'requestID'];
                keys_to_remove.forEach(key => {
                    if (v1.Out[key] != null) {
                        saved_space += JSON.stringify(v1.Out[key]).length;
                        return delete v1.Out[key];
                    }
                    return undefined;
                });
                const history = IRIS.history[k1];
                _.forEach(v1.Out, (v2, k2) => {
                    if (v2 != null) {
                        const size = JSON.stringify(v2).length;
                        if (size > 1024) {
                            v2 = null;
                            saved_space += size;
                            const obj = history?.Out;
                            if (obj) {
                                obj[k2] = v2;
                            }
                        }
                    }
                });
                if (history) {
                    history.Out = v1.Out;
                }
            }
        });
        if (saved_space > 2048) {
            const kb_saved = Math.round(saved_space / 1024);
            irislog(`GC Completed - KB reclaimed: ${kb_saved}`);
        }
    }
    Ping(is_native) {
        this.Send({
            data: {
                progID: 0,
                funcID: is_native ? 9 : 2,
                string: 'testing',
            },
            yes: data => {
                console.log(data);
            },
            no: data => {
                console.log(data);
            },
        });
    }
}
let showingErrorReconnectingMessage = false;
let errorReconnectingFlyout = null;
const showErrorReconnectingMessage = () => {
    if (showingErrorReconnectingMessage) {
        return;
    }
    const title = 'Network Error';
    const flyoutForm = (React.createElement("form", { onSubmit: e => {
            e.preventDefault();
            errorReconnectingFlyout?.Close();
            return false;
        } },
        React.createElement("p", null, "Error reconnecting to server"),
        React.createElement("div", { style: { textAlign: 'center' } },
            React.createElement(Button, { type: "submit", lbl: "OK", style: { width: '120px' } }))));
    showingErrorReconnectingMessage = true;
    errorReconnectingFlyout = reactFlyout(title, [260, 170], flyoutForm, {
        closeCallback: () => {
            showingErrorReconnectingMessage = false;
        },
    });
};
const getCookies = () => {
    const cookieObj = new Map();
    document.cookie.split('; ').forEach(cookie => {
        const keyValue = cookie.split('=');
        const key = keyValue[0] ? decodeURIComponent(keyValue[0]) : '';
        const value = keyValue[1] ? decodeURIComponent(keyValue[1]) : '';
        if (key && value) {
            cookieObj.set(key, value);
        }
    });
    return cookieObj;
};
export const IRIS = new IrisClient();
IRIS.Run();
//# sourceMappingURL=component-iris.js.map